export default __webpack_public_path__ + "static/media/arrow-down-red.6abdc372.svg";